import { createRouter, type RouterHistory } from "@tanstack/react-router";

import { routeTree } from "../routeTree.gen";
import { RoutePageError } from "./page-error";

export function createAppRouter(history?: RouterHistory) {
  return createRouter({
    routeTree,
    defaultErrorComponent: RoutePageError,
    ...(history ? { history } : {}),
  });
}

export const router = createAppRouter();

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
